<template>
  <div class="watch">
    <div
      class="watch-btn"
      @mouseover="isShow = true"
      @mouseleave="isShow = false"
    >
      <i class="el-icon-mobile-phone icon"></i>
      <span class="title">手机观看</span>
    </div>
    <div
      class="watch-qr animated"
      :class="{ fadeIn: isShow }"
      :style="`display: ${isShow ? 'block' : 'none'};
      width: ${qrcodeWidth};height: ${qrcodeHeight};`"
    >
      <vue-qr :logoSrc="icon" :text="url" :size="200"></vue-qr>
    </div>
  </div>
</template>

<script>
// vue2.0
import VueQr from 'vue-qr'
// vue3.0 (support vite)
// import vueQr from 'vue-qr/src/packages/vue-qr.vue'
export default {
  name: 'Qrcode',

  components: {
    VueQr
  },

  props: {
    url: {
      // 二维码地址
      type: String,
      require: true
    },
    show: {
      // 二维码是否显示
      type: Boolean,
      default: false
    },
    icon: {
      // 二维码中间的icon图标
      type: String,
      default: ''
    },
    qrcodeWidth: {
      // 二维码框的宽度
      type: String,
      default: '200px'
    },
    qrcodeHeight: {
      // 二维码框的宽度
      type: String,
      default: '200px'
    }
  },

  data() {
    return {
      isShow: this.show
    }
  },

  mounted() {},

  methods: {}
}
</script>

<style lang="less" scoped>
.watch {
  display: inline-block;
  position: relative;
  z-index: 100;
  height: 100%;
  width: 100px;
  text-align: center;
}
.watch-btn {
  color: #fff;
  cursor: pointer;
  i {
    vertical-align: middle;
    display: inline-block;
    width: 11px;
    height: 15px;
  }
  .title {
    vertical-align: middle;
    font-size: 14px;
    margin-left: 7px;
  }
}
.watch-qr {
  display: none;
  transform: all 0.3s;
  position: absolute;
  bottom: 100%;
  left: calc(50% - 140px);
  padding: 10px;
  width: 200px;
  height: 200px;
  background: #27282e;
  border-radius: 5px;
  img {
    border-radius: 5px;
    width: 100%;
    height: 100%;
  }
}
</style>
